<template>
  <div v-if="user.id">

    <div class="ibox">
      <div class="ibox-title pt-3">
        <h5><strong>Perfil de usuário</strong></h5>
      </div>

      <div class="ibox-content">
        <div class="row mt-3 mb-3">
          <div class="col-md-4" v-if="user.image">
            <img style="width: 250px" :src="user.image" class="img-fluid rounded-circle img-thumbnail">
          </div>
          <div class="col-md-8" :class="{'mt-5': user.image}">
            <h5><p><strong>{{ user.name }}</strong></p></h5>
            <p><strong>Email: </strong>{{ user.email }}</p>
            <p><strong>Perfil: </strong>{{ user.role | t }}
              <small class="text-muted">— derivado do grupo de permissão</small>
            </p>
            <p v-if="user.id === getUser.id">
              <strong>Token (API): </strong>
              <span class="mr-2" title="Clique para copiar">
                ● ● ● ● ● ● ● ● ● ● ● ● ● ● ●
<!--                {{ user.accountUser.apiToken}}-->

              </span>
              <span>
                <CopyIcon
                    @click="copyToken()"
                    class="fd-icon mr-4"
                    v-tooltip.bottom="{content: this.tokenClick}"
                />
              </span>
              <a href="#" @click.prevent="renewToken()">(Gerar novo token)</a>
            </p>
          </div>
        </div>

        <div class="row mt-2">

          <template v-if="$withPolicy()">
            <div class="col-md-12">
              <button class="btn btn-outline btn-md mr-2" @click="editUser">{{'btn.edit' | t}}</button>

              <button v-if="user.id !== getUser.id" class="btn btn-outline-red btn-lg float-right" @click="deleteUser">
                Excluir usuário
              </button>
            </div>
          </template>

        </div>
      </div>
    </div>

    <template v-if="load">
      <CardCompanies :user="user"/>

      <user-access-panel :read-only="true" :value="groupIds"/>
    </template>

  </div>
</template>

<script>
  import GetUser from '@/mixins/GetUser'
  import CardCompanies from '@/components/user/CardCompanies'
  import UserAccessPanel from '@/components/user/UserAccessPanel'

  import User from '@/models/User'
  import { CopyIcon } from 'vue-feather-icons'

  export default {
    components: { CardCompanies, CopyIcon, UserAccessPanel },
    computed: {
      groupIds() {
        return (this.user.permissionGroups || []).map(group => group.id)
      }
    },
    created() {
      const params = { includes: ['account_user', 'policies', 'permission_groups'] }

      this.axios.get(`users/${this.userId}`, { params })
      .then(resp => this.user = User.build(resp.data))
      .finally(() => this.load = true)
    },
    data() {
      return {
        load: false,
        tokenClick: 'Clique para copiar',
        user: {},
      }
    },
    methods: {
      copyToken() {
        const input = document.createElement('input')
        input.value = this.user.accountUser.apiToken
        document.body.appendChild(input)
        input.select();
        document.execCommand('copy')
        document.body.removeChild(input)
        this.tokenClick = 'Token copiado!'
        setTimeout(() => {
          this.tokenClick = 'Clique para copiar'
        }, 2000)
      },
      deleteUser() {
        this.$emit('sendDeleteUser', this.user)
      },
      editUser(){
        this.$emit('editUser', this.user)
      },
      renewToken() {
        const confirmed = window.confirm('Deseja realmente gerar um novo token?')
        if (confirmed) {
          this.$emit('renewToken', this.user)
        }
      }
    },
    mixins: [GetUser],
    name: 'Show',
    props: ['userId']
  }
</script>

<style scoped lang="scss">
.card{
  height: 100%;
}

p{
  color: black;
}

.table td{
  vertical-align: middle;
}

.fd-icon:hover {
  cursor: pointer;
  color: #15CE9A;
  transition: all 0.2s ease-in-out;
}

</style>
